import PropTypes from "prop-types";
import { connect } from "react-redux";
import { resolutionPropType } from "app/utils/propTypes";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { useLocation, useParams } from "react-router-dom";
import { checkSpecialOfferForSelectedDepartureDate } from "app/pages/Booking/Payment/paymentSelector";
import SpecialOffer from "app/pages/.shared/SpecialOffer/SpecialOffer";
import { isServerSide, isUserMatchWithType } from "app/utils/utils";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { useFlagship, useFsFlag } from "@flagship.io/react-sdk";

const SearchEngineMessagePlaceholderContainer = ({
	specialOffer = {},
	fallBackSpecialOffer = {},
	isSpecialOfferActive,
	resolution,
	userIsConnected,
}) => {
	const location = useLocation();
	const isBookingSearchPage = location?.pathname?.includes("/booking/search");
	const { productUri } = useParams();

	let spo = undefined;

	const usersFilterType = specialOffer?.ui?.usersFilter;
	const checkUserType = isUserMatchWithType(usersFilterType, userIsConnected);

	const fsShowFallbackSpecialOffer = useFsFlag("fallback_special_offer_show", true);
	const { status: fsStatus } = useFlagship();

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;
	if (!isMobile) {
		const isProductPage = Boolean(productUri);
		const shouldDisplaySpecialOfferOnCurrentPage =
			checkUserType &&
			isSpecialOfferActive &&
			(specialOffer.pages &&
				specialOffer.pages.find(page => {
					return (
						location.pathname.includes(page) || (page === "product" && isProductPage)
					);
				}));

		const shouldDisplaySpecialOfferFallbackOnCurrentPage =
			checkUserType &&
			(fsStatus.isSdkReady || (!isServerSide && window.Cypress)) &&
			fsShowFallbackSpecialOffer.getValue() &&
			fallBackSpecialOffer.pages &&
			fallBackSpecialOffer.pages.find(page => {
				return location.pathname.includes(page) || (page === "product" && isProductPage);
			});

		if (shouldDisplaySpecialOfferOnCurrentPage) {
			spo = specialOffer;
		} else if (shouldDisplaySpecialOfferFallbackOnCurrentPage) {
			spo = fallBackSpecialOffer;
		}
	}
	const shouldDisableFlexSpecialOffer = spo?.code === "FLEX";
	if (shouldDisableFlexSpecialOffer) {
		return null;
	}

	// specialOffer.ui.background n'est pas passé à SpecialOffer pour ne pas avoir un block trop voyant ici
	return spo && !isBookingSearchPage ? (
		<div className="booking-marketing-placeholder">
			<div className="search-engine-message-placeholder">
				<SpecialOffer
					type={spo.type}
					title={spo.title}
					message={spo.summary}
					background={spo?.ui?.background}
					titleColor={spo?.ui?.titleColor}
					textColor={spo?.ui?.textColor}
					pictoUrl={spo?.ui?.pictoUrl}
					tooltipMessage={spo.details}
				/>
			</div>
		</div>
	) : null;
};

SearchEngineMessagePlaceholderContainer.propTypes = {
	resolution: resolutionPropType,
	isSpecialOfferActive: PropTypes.bool,
	specialOffer: PropTypes.object,
	fallBackSpecialOffer: PropTypes.object,
	userIsConnected: PropTypes.bool,
};

const mapStateToProps = state => {
	return {
		specialOffer: state.ficheProduit.specialOffer,
		fallBackSpecialOffer: state.partner.fallbackSpecialOffer,
		isSpecialOfferActive: checkSpecialOfferForSelectedDepartureDate(state),
		resolution: state.resolution,
		userIsConnected: isAuthenticated(state),
	};
};

export default connect(mapStateToProps)(SearchEngineMessagePlaceholderContainer);
